export const NO_ANSWER = "NO_ANSWER";
export const FAILED = "FAILED";
export const ANSWERED = "ANSWERED";
export const CANCEL = "CANCEL";
